import { useState } from "react";
import "./order.css";
import { ChevronDown, ChevronUp, SaudiRiyal } from "lucide-react";

const OrderDetails = ({ product }) => {
  const [openItemId, setOpenItemId] = useState(null);

  const unitPriceList =
    product?.modifier_sets?.map((m) => Number(m.final_price) || 0) || [];

  const unitPrice =
    unitPriceList.reduce((acc, p) => acc + p, 0) + Number(product.final_price);

  const totalPrice = unitPrice * product.quantity;

  const toggleItem = (id) => {
    setOpenItemId(openItemId === id ? null : id);
  };

  return (
    <>
      <div className="accordion-wrapper">
        <div className="accordion-item">
          <div
            className="accordion-header"
            onClick={() => toggleItem(product.id)}
          >
            <div className="title">
              {product.quantity} × {product.product.name}
            </div>
            <div>
              {" "}
              <span className="heading-price">
                {totalPrice}
                <SaudiRiyal size={13} />
              </span>
              <span className="arrow">
                {openItemId === product.id ? <ChevronUp /> : <ChevronDown />}
              </span>
            </div>
          </div>

          {openItemId === product.id && (
            <div className="accordion-body">
              <div className="type-details">
                <p>النوع: {product.variation.name}</p>
                <p className="price">
                  {product.final_price} <SaudiRiyal size={12} />
                </p>
              </div>
              {product.modifier_sets?.length > 0 && (
                <>
                  <p style={{ fontSize: "12px", margin: "0" }}>الإضافات:</p>
                  <ul className="addon-details">
                    {product.modifier_sets.map((m) => (
                      <li key={m.id} className="addon-item">
                        <span className="addon-name">
                          {m.product.name} (
                          {m.variations.map((v) => v.name).join(", ")})
                        </span>
                        <span className="price">
                          {m.final_price} <SaudiRiyal size={12} />
                        </span>
                      </li>
                    ))}
                  </ul>

                  <hr />

                  <div className="accordion-footer-price">
                    <p>إجمالي الصنف:</p>
                    <p className="price">
                      {unitPrice} <SaudiRiyal size={13} />
                    </p>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default OrderDetails;
